<template>
	<div style="width: 100%;height: 100%;">
		<div style="width: 100%;height: 30%;background-image: linear-gradient(to top right, #DAFBFF, #CACCFF)">
			<div style="color: #415474;font-size: 24px;margin-left: 5%;padding-top: 10%;font-weight: 500;float: left;">
				预约检测
			</div>
			<div @click="out" style="margin-right: 5%;margin-top:10%;font-size:12px;color:white;float: right;border: 1px solid white;border-radius: 5px;padding: 4px 10px;text-align: center;">
				退出
			</div>
			<div style="height: 45%;width: 100%;"></div>
			<div @click="toReservation()" style="font-size: 14px;width: 36%;margin-left: 32%;height: 40px;line-height: 40px;text-align: center;color: #477AB5;background-color: white;border-radius: 50px;">
				立即预约
			</div>
			<div style="font-size: 14px;text-align: center;margin-top: 10px;color: #477AB5;">今日剩余名额：{{ number }}个</div>
		</div>

		<div style="width: 100%;height: 75%;margin-top: -5%;background-color: white;border-radius: 25px;">
			<div style="width: 100%;height: 1px;padding-top: 20px;"></div>
			<div style="height: 100px;width: 90%;margin: 5%;margin-top: 0px;border-radius: 10px;box-shadow: 1px 1px 4px 1px #EEF5F9;">
				<img src="../../assets/fImage/1.png" style="float: left;margin-left: 20px;width: 50px;height: 50px;margin-top: 25px;border-radius: 10px;">
				<div style="float: left;margin-left: 10px;">
					<div style="font-size: 14px;margin-top: 30px;">预约状态</div>
					<div style="font-size: 12px;color: #A6A6A6;margin-top: 6px;">总共已预约{{totalNumber}}次</div>
				</div>
				<div v-if="haveNoOver" style="font-size: 12px;color: #477AB5;float: right;margin-right: 20px;border: 1px solid #477AB5;border-radius: 25px;padding: 4px 0px;margin-top: 35px;width: 70px;text-align: center;">
					预约成功
				</div>
				<div v-else style="font-size: 12px;color: #477AB5;float: right;margin-right: 20px;border: 1px solid #477AB5;border-radius: 25px;padding: 4px 0px;margin-top: 35px;width: 70px;text-align: center;">
					未预约
				</div>
			</div>
			<div style="height: 100px;width: 90%;margin: 5%;margin-top: 25px;border-radius: 10px;box-shadow: 1px 1px 4px 1px #EEF5F9;">
				<img src="../../assets/fImage/2.png" style="float: left;margin-left: 20px;width: 50px;height: 50px;margin-top: 25px;border-radius: 10px;">
				<div style="float: left;margin-left: 10px;">
					<div style="font-size: 14px;margin-top: 30px;">检测结果</div>
					<div style="font-size: 12px;color: #A6A6A6;margin-top: 6px;">可查看详细身体报告</div>
				</div>
				<div @click="showPdf()" style="font-size: 12px;color: #477AB5;float: right;margin-right: 20px;border: 1px solid #E9F2FF;background-color: #E9F2FF;border-radius: 25px;padding: 4px 0px;margin-top: 35px;width: 70px;text-align: center;">
					查看
				</div>
			</div>
			<div style="height: 100px;width: 90%;margin: 5%;margin-top: 25px;border-radius: 10px;box-shadow: 1px 1px 4px 1px #EEF5F9;">
				<img src="../../assets/fImage/3.png" style="float: left;margin-left: 20px;width: 50px;height: 50px;margin-top: 25px;border-radius: 10px;">
				<div style="float: left;margin-left: 10px;">
					<div style="font-size: 14px;margin-top: 30px;">结果反馈</div>
					<div style="font-size: 12px;color: #A6A6A6;margin-top: 6px;">根据检测报告反馈结果</div>
				</div>
				<div @click="toFeedback()" style="font-size: 12px;color: #477AB5;float: right;margin-right: 20px;border: 1px solid #E9F2FF;background-color: #E9F2FF;border-radius: 25px;padding: 4px 0px;margin-top: 35px;width: 70px;text-align: center;">
					填写
				</div>
			</div>
			<div style="height: 100px;width: 90%;margin: 5%;margin-top: 25px;border-radius: 10px;box-shadow: 1px 1px 4px 1px #EEF5F9;">
				<img src="../../assets/fImage/3.png" style="float: left;margin-left: 20px;width: 50px;height: 50px;margin-top: 25px;border-radius: 10px;">
				<div style="float: left;margin-left: 10px;">
					<div style="font-size: 14px;margin-top: 30px;">预约调理</div>
					<div style="font-size: 12px;color: #A6A6A6;margin-top: 6px;">在线预约身体调理</div>
				</div>
				<div style="float: right;">

					<div @click="toConditioning()" v-if="!conditioning" style="font-size: 12px;color: #477AB5;margin-right: 20px;border: 1px solid #E9F2FF;background-color: #E9F2FF;border-radius: 25px;padding: 4px 0px;margin-top: 35px;width: 70px;text-align: center;">
						预约
					</div>
					<div @click="toConditioning()" v-if="conditioning" style="font-size: 12px;color: #477AB5;margin-right: 20px;border: 1px solid #E9F2FF;background-color: #E9F2FF;border-radius: 25px;padding: 4px 0px;margin-top: 35px;width: 70px;text-align: center;">
						查看
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {getTodayNumber,getIsNoOver,getTotalNumber,getIsNoOverConditioning,getResult} from "@/api/reservation";
	import Cookies from 'js-cookie';
	export default {
		name: "Index",
		data() {
			return {
				imgList: [],
				screenHeight:1000,
				screenWidth:500,
				number:20,
				flag:1,
				phone: Cookies.get('phone'),
				haveNoOver:false,
				totalNumber:0,
				conditioning:{},
				pdfUrl:'https://quantum-health.oss-cn-hangzhou.aliyuncs.com/pdf018ab3b8-fc30-45ba-b9d9-0dd138ad7c0620230720.pdf'
			}
		},
		created() {
			this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;
			if(!this.phone){
				this.$router.push(
					{
						path:'/phone/login',
					}
				);
			}
			this.getNumber()
			this.getIsNoOverF()
			this.getTotalNumberF()
			this.getIsNoOverConditioningF()
		},
		activated() {
			this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;
			if(!this.phone){
				this.$router.push(
					{
						path:'/phone/login',
					}
				);
			}
			this.getNumber()
			this.getIsNoOverF()
			this.getTotalNumberF()
			this.getIsNoOverConditioningF()
		},
		mounted() {
			this.screenWidth = window.innerWidth;
      this.screenHeight = window.innerHeight;
			if(!this.phone){
				this.$router.push(
					{
						path:'/phone/login',
					}
				);
			}
			this.getNumber()
			this.getIsNoOverF()
			this.getTotalNumberF()
			this.getIsNoOverConditioningF()
		},
		methods: {
			showPdf(){
				getResult(this.phone).then(data => {
					if(data.data){
						let url = data.data.res_url
						window.open(url)
					}else{
						this.$message.error("暂无检测结果，请耐心等待")
					}
				}).catch(error =>{
					this.$message.error(error)
				})
				
			},
			toFeedback(){
				this.$router.push(
					{
						path:'/phone/feedback',
					}
				);
			},
			out(){
				// 删除cookie
				Cookies.remove('phone');
				this.$router.push(
					{
						path:'/phone/login',
					}
				);
			},
			toConditioning(){
				if(this.conditioning){
					this.$router.push(
						{
							path:'/phone/conditioning',
							query:{
								item:JSON.stringify(this.conditioning),
							}
						}
					);
				}else{
					this.$router.push(
						{
							path:'/phone/conditioning'
						}
					);
				}
			},
			getNumber(){
				getTodayNumber().then(data => {
					this.number = data.data
				}).catch(error =>{
					this.$message.error(error)
				})
			},
			getIsNoOverF(){
				if(this.phone){
					getIsNoOver(this.phone).then(data => {
						if(data.data >=1){
							this.haveNoOver = true;
						}else{
							this.haveNoOver = false;
						}
					}).catch(error =>{
						this.$message.error(error)
					})
				}
				
			},
			getTotalNumberF(){
				getTotalNumber(this.phone).then(data => {
					this.totalNumber = data.data;
				}).catch(error =>{
					this.$message.error(error)
				})
			},
			getIsNoOverConditioningF(){
				getIsNoOverConditioning(this.phone).then(data => {
					this.conditioning = data.data;
				}).catch(error =>{
					this.$message.error(error)
				})
			},
			toReservation(){
				if(this.haveNoOver){
					this.$message.error("存在未完成的预约。")
				}else{
					this.$router.push(
					{
						path:'/phone/reservation',
					}
				);
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	.main-containter ::v-deep .el-carousel__indicators--horizontal{
		display: none;
	}

	.parentCarousel ::v-deep .el-carousel__container{
		height: 100%;
	}
	body ::v-deep .v-modal{
		display: none;
	}
</style>
